import React from 'react';
import { IpaType } from '../../phonemes/ipa';
import { NonPulmonicChart } from './NonPulmonicChart';
import { ConsonantChart } from './ConsonantChart';
import { VowelChart } from './VowelChart';
import './chart.css';
import { ToneChart } from './ToneChart';
import { FormantsChart } from './FormantsChart';
import { MiscChart } from './MiscChart';

export interface IpaChartProps {
  /** true: all consonants in one chart; false: separate non-pulmonics; default: false */
  readonly combinedConsonants?: boolean;
  /** if combinedConsonants, show formants, optionally using these diphthongs */
  readonly diphthongs?: string[];
  /** include other common or interesting IPA segments not otherwise on chart */
  readonly misc?: boolean;

  /** what to display for a given IPA string */
  readonly lookup: (ipa: IpaType) => string;
  /** called when a symbol is clicked on */
  readonly clicked?: (ipa: IpaType) => void;
  /** true if a call to 'clicked' will do something useful */
  readonly canClick?: (ipa: IpaType) => boolean;
  /** called when the mouse is over a symbol */
  readonly hovered?: (ipa: IpaType) => void;
  /** what background color to use for a given IPA string */
  readonly background?: (ipa: IpaType) => string | undefined;
  /** add a <br/> between the two symbols in a cell */
  readonly br?: boolean;
}

/** show IPA charts of consonants and vowels */
export function IpaChart(props: IpaChartProps) {
  return (
    <div style={{ display: 'grid' }}>
      <div className='consonants'>
        <div className='tablelabel'>consonants</div>
        <ConsonantChart includeNonPulmonics={props.combinedConsonants ? 'nonPulmonics' : 'none'}
          lookup={props.lookup} clicked={props.clicked} canClick={props.canClick} hovered={props.hovered} background={props.background} br={props.br} />
      </div>
      {props.combinedConsonants ? undefined :
        <div className='cell21'>
          <div className='tablelabel'>nonpulmonic consonants</div>
          <NonPulmonicChart lookup={props.lookup} clicked={props.clicked} canClick={props.canClick} hovered={props.hovered} background={props.background} />
        </div>
      }
      <div className={props.combinedConsonants ? 'cell21' : 'cell22'}>
        <div className='tablelabel'>vowels</div>
        <VowelChart lookup={props.lookup} clicked={props.clicked} canClick={props.canClick} hovered={props.hovered} background={props.background} />
      </div>
      {!props.combinedConsonants ? undefined :
        <div className='cell22'>
          <FormantsChart width={400} height={210}
            lookup={props.lookup} clicked={props.clicked} hovered={props.hovered} diphthongs={props.diphthongs} />
        </div>
      }
      <div className='cell23'>
        <div className='tablelabel'>tones</div>
        <ToneChart lookup={props.lookup} clicked={props.clicked} canClick={props.canClick} hovered={props.hovered} background={props.background} />
      </div>
      {!props.misc ? undefined :
        <div className='other'>
          <br />
          <MiscChart lookup={props.lookup} clicked={props.clicked} canClick={props.canClick} hovered={props.hovered} background={props.background} />
        </div>
      }
    </div>
  );
}

